import { Libraries } from '@react-google-maps/api';

export const mapLibraries: Libraries = ['routes'];
